import { medicationNotification$ } from '@communicare/medications/Config/ApplicationConfig';

let defaultErrorMessage: string  = "There was a problem completing your request.";

let toast = {
    showError :(message?:string) => {
        message = (message != null) ? message : defaultErrorMessage;
        medicationNotification$.next({
            type:'error',
            message:message });
    },
    showMessage :(message:string) => {
        medicationNotification$.next({
            type:'display',
            message:message });
    }
};

export {toast};